import { connect } from 'react-redux';
import ModalConfirmForm from './ModalConfirmForm';
import { performBulkAction } from '../../../redux/actions';

const mapDispatchToProps = {
  onSubmit: performBulkAction,
};

export default connect(null, mapDispatchToProps)(ModalConfirmForm);
